import * as actionType from "./constants";
import { DEFAULT_CHART_PARAMS, DEFAULT_CHART_VIEW } from "./constants";

const initialState = {
    entityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null,
            order: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null
    },
    chartDataResponse: {},
    gaugeChartResponse: {},
    selectedMasterFilters: {
        region_ids: [],
        site_ids: [],
        building_ids: [],
        building_type_ids: [],
        asset_status_ids: [],
        asset_condition_ids: [],
        asset_type_ids: [],
        recommendation_assigned: null
    },
    chartMasterFilterList: {
        regions: [],
        sites: [],
        buildings: [],
        building_types: [],
        asset_statuses: [],
        asset_conditions: [],
        asset_types: [],
        recommendation_filter: []
    },
    chartPopupData: { show: false, data: {} },
    chartTab: "dashboard",
    chartParams: { ...DEFAULT_CHART_PARAMS },
    chartView: { ...DEFAULT_CHART_VIEW },
    assetImportHistoryEntityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null,
            order: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null
    },
    assetImportHistory: null,
    deleteAssetImportHistory: null,
    getAssetDashboardMap: {}
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case actionType.UPDATE_ASSET_MANAGEMENT_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: { ...action.response }
            };
        case actionType.UPDATE_ASSET_MANAGEMENT_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { ...action.error }
            };
        case actionType.GET_CHARTS_DETAILS_REQUEST:
            return {
                ...state,
                chartDataResponse: { ...state.chartDataResponse, [action.key]: { loading: true } }
            };
        case actionType.GET_CHARTS_DETAILS_SUCCESS:
            return {
                ...state,
                chartDataResponse: { ...state.chartDataResponse, [action.key]: { loading: false, ...action.response } }
            };
        case actionType.GET_CHARTS_DETAILS_FAILURE:
            return {
                ...state,
                chartDataResponse: { ...state.chartDataResponse, [action.key]: { loading: false, success: false, ...action.error } }
            };
        case actionType.GET_WEIGHTED_AVERAGE_CHART_REQUEST:
            return {
                ...state,
                chartDataResponse: {
                    ...state.chartDataResponse,
                    weighted_average_chart: { ...state.chartDataResponse?.weighted_average_chart, loading: true }
                }
            };
        case actionType.GET_WEIGHTED_AVERAGE_CHART_SUCCESS:
            return {
                ...state,
                chartDataResponse: {
                    ...state.chartDataResponse,
                    weighted_average_chart: { loading: false, ...action.response }
                }
            };
        case actionType.GET_WEIGHTED_AVERAGE_CHART_FAILURE:
            return {
                ...state,
                chartDataResponse: {
                    ...state.chartDataResponse,
                    weighted_average_chart: { loading: false, success: false, ...action.error }
                }
            };
        case actionType.GET_FILTER_LISTS_REQUEST:
            return {
                ...state
            };
        case actionType.GET_FILTER_LISTS_SUCCESS:
            return {
                ...state,
                chartMasterFilterList: { ...state.chartMasterFilterList, [action.filterKey]: [...action.response[action.filterKey]] }
            };
        case actionType.GET_FILTER_LISTS_FAILURE:
            return {
                ...state,
                chartMasterFilterList: { success: false, ...action.error }
            };
        case actionType.GET_ASSET_GAUGE_CHART_REQUEST:
            return {
                ...state,
                gaugeChartResponse: { loading: true }
            };
        case actionType.GET_ASSET_GAUGE_CHART_SUCCESS:
            return {
                ...state,
                gaugeChartResponse: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_ASSET_GAUGE_CHART_FAILURE:
            return {
                ...state,
                gaugeChartResponse: { loading: false, success: false, ...action.error }
            };
        case actionType.GET_SFCI_CHART_REQUEST:
            return {
                ...state,
                chartDataResponse: {
                    ...state.chartDataResponse,
                    asset_benchmark: { ...state.chartDataResponse?.asset_benchmark, loading: true }
                }
            };
        case actionType.GET_SFCI_CHART_SUCCESS:
            return {
                ...state,
                chartDataResponse: {
                    ...state.chartDataResponse,
                    asset_benchmark: {
                        loading: false,
                        ...action.response
                    }
                }
            };
        case actionType.GET_SFCI_CHART_FAILURE:
            return {
                ...state,
                chartDataResponse: {
                    ...state.chartDataResponse,
                    asset_benchmark: {
                        loading: false,
                        success: false,
                        ...action.error
                    }
                }
            };
        case actionType.GET_ASSET_DASHBOARD_MAP_REQUEST:
            return {
                ...state,
                getAssetDashboardMap: { isLoading: true }
            };
        case actionType.GET_ASSET_DASHBOARD_MAP_SUCCESS:
            return {
                ...state,
                getAssetDashboardMap: { success: true, ...action.response, isLoading: false }
            };
        case actionType.GET_ASSET_DASHBOARD_MAP_FAILURE:
            return {
                ...state,
                getAssetDashboardMap: { success: false, ...action.error, isLoading: false }
            };
        case actionType.SAVE_CHART_POPUP:
            return {
                ...state,
                chartPopupData: action.response
            };
        case actionType.SAVE_CHART_TAB:
            return {
                ...state,
                chartTab: action.response
            };
        case actionType.SAVE_CHART_VIEW:
            return {
                ...state,
                chartView: action.response
            };
        case actionType.SAVE_CHART_PARAMS:
            return {
                ...state,
                chartParams: action.response
            };
        case actionType.SAVE_SELECTED_MASTER_FILTER_LIST:
            return {
                ...state,
                selectedMasterFilters: action.response
            };
        case actionType.GET_ASSET_IMPORT_HISTORY_REQUEST:
            return {
                ...state,
                assetImportHistory: { loading: true }
            };
        case actionType.GET_ASSET_IMPORT_HISTORY_SUCCESS:
            return {
                ...state,
                assetImportHistory: { loading: false, success: true, ...action.response }
            };
        case actionType.GET_ASSET_IMPORT_HISTORY_FAILURE:
            return {
                ...state,
                assetImportHistory: { loading: false, success: false, ...action.error }
            };
        case actionType.DELETE_ASSET_IMPORT_HISTORY_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_ASSET_IMPORT_HISTORY_SUCCESS:
            return {
                ...state,
                deleteAssetImportHistory: { success: true, ...action.response }
            };
        case actionType.DELETE_ASSET_IMPORT_HISTORY_FAILURE:
            return {
                ...state,
                deleteAssetImportHistory: { success: false, ...action.error }
            };
        default:
            return state;
    }
};

export default reducers;
